module.exports = __webpack_public_path__ + "static/media/landing-features-img.0b71ae51.svg";